// @flow
// $FlowFixMe
import React, { useEffect, useMemo } from "react";
// $FlowFixMe
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { get, noop, attempt, isError } from "lodash";
import type { Dispatch } from "redux";
import ModalV2 from "@fdr/atomic-ui/_templates/ModalV2";
import PowerRatingImage from "@fdr/static-ui/SvgImages/PowerRating";
import CarrerFirstImage from "@fdr/static-ui/SvgImages/CarrerFirst";
import CarrerTopImage from "@fdr/static-ui/SvgImages/CarrerTop";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";
import type {
  HelpProps,
  HelpDescription,
  HelpBetDescription,
  HelpTutorialDescription,
  WinProbabilityFDR
} from "@fdr/types/ProgramPage";
import type { WagerTypeCodesEnum } from "@tvg/types/Wager";
import { events as AlchemerEvents } from "@urp/alchemer";
import HelpModalTemplate from "@fdr/atomic-ui/_templates/HelpModal";
import Toast from "@fdr/atomic-ui/_atoms/Toast";
import {
  getGeolocationMessageShown,
  getGeolocationStatus
} from "@tvg/sh-geolocation/src/redux/selectors";
import { geolocationStatusClear } from "@tvg/sh-geolocation/src/redux/actions";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import { setSelectedSlug } from "@fdr/tutorials/src/redux/actions";
import useContentData from "@fdr/tutorials/src/hooks/useContentData";

const defaultDescription = {
  title: "",
  image: null,
  description: "",
  tip: ""
};

export const filterWagerTypes = (
  parsedBetTypes: HelpBetDescription,
  betTypeCode: WagerTypeCodesEnum
) => ({
  ...parsedBetTypes,
  typesList: parsedBetTypes.typesList.filter((betType) =>
    betType.types.includes(betTypeCode)
  )
});

export const getMessages = (
  props: HelpProps
):
  | HelpDescription
  | HelpBetDescription
  | HelpTutorialDescription
  | WinProbabilityFDR => {
  const {
    powerRating,
    highSpeed,
    winPerc,
    topPerc,
    coupled,
    numberFire,
    racingAndSports,
    betTypes,
    type,
    understandingPools,
    understandingOdds,
    winProbabilityFDR,
    currentBetType
  } = props;

  let parsedBetTypes = attempt((json) => JSON.parse(json), betTypes);
  const parsedUnderstandingPools = attempt(
    (json) => JSON.parse(json),
    understandingPools
  );
  let parsedUnderstandingOdds = attempt(
    (json) => JSON.parse(json),
    understandingOdds
  );
  const code = get(currentBetType, "type.code");

  if (isError(parsedBetTypes)) {
    parsedBetTypes = {
      title: "",
      typesList: []
    };
  }

  if (isError(parsedUnderstandingOdds)) {
    parsedUnderstandingOdds = {
      title: "",
      description1: "",
      description2: "",
      description3: ""
    };
  }

  if (currentBetType && code) {
    parsedBetTypes = filterWagerTypes(parsedBetTypes, code);
  }

  const typeMap = {
    "PWR RATING": powerRating,
    "HIGH SPEED": highSpeed,
    "WIN %": winPerc,
    "TOP 3": topPerc,
    "Coupled Runners": coupled,
    "NumberFire Stats": numberFire,
    "Racing and Sports": racingAndSports,
    "understanding pools": parsedUnderstandingPools,
    "understanding odds": parsedUnderstandingOdds,
    "bet types": parsedBetTypes,
    "WIN PROB": winProbabilityFDR
  };
  return typeMap[type];
};

export const HelpModal = (props: HelpProps) => {
  const {
    isOpen,
    closeModal,
    templateType,
    hasNotApplicableDesc,
    geolocationStatus,
    geolocationMessageShown,
    geoLocationToastMsg,
    dispatch,
    storedSlugContent
  } = props;
  const message = getMessages(props);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setSelectedSlug("modals/betting"));
  }, []);

  const { contentData, isLoading } = useContentData(
    "modals/betting",
    dispatch,
    storedSlugContent
  );

  const onBetModalFooterClick = () => {
    AlchemerEvents.selectLearnHorseRacing();
    closeModal();
    navigate("/tutorials");
  };

  return useMemo(
    () => (
      <ModalV2
        onClose={closeModal}
        title={get(message, "title", "")}
        isOpen={isOpen}
        hasShadow
        isFullHeight={false}
        animation="bottom"
        modalTopChildren={() =>
          !isXSell() &&
          geoLocationToastMsg &&
          geolocationStatus &&
          geoLocationToastMsg[geolocationStatus] && (
            <Toast
              {...geoLocationToastMsg[geolocationStatus]}
              noAnimation={geolocationMessageShown}
              callback={() => dispatch(geolocationStatusClear())}
            />
          )
        }
      >
        {() => (
          <HelpModalTemplate
            type={templateType}
            message={message}
            hasNotApplicableDesc={hasNotApplicableDesc}
            contentData={contentData}
            isLoading={isLoading}
            onBetModalFooterClick={onBetModalFooterClick}
          />
        )}
      </ModalV2>
    ),
    [isOpen, message, templateType]
  );
};

HelpModal.defaultProps = {
  isOpen: false,
  type: "PWR RATING",
  templateType: "help",
  closeModal: noop,
  powerRating: {
    ...defaultDescription,
    notApplicable: ""
  },
  highSpeed: {
    ...defaultDescription,
    notApplicable: ""
  },
  winPerc: {
    ...defaultDescription
  },
  topPerc: {
    ...defaultDescription
  },
  coupled: {
    ...defaultDescription
  },
  numberFire: { ...defaultDescription },
  racingAndSports: { ...defaultDescription },
  betTypes: { title: "", typesList: [] },
  understandingPools: {
    title: "",
    description1: "",
    description2: "",
    description3: ""
  },
  understandingOdds: {
    title: "",
    description1: "",
    description2: "",
    description3: ""
  },
  hasNotApplicableDesc: false,
  winProbabilityFDR: {
    title: "",
    description: ""
  },
  currentBetType: undefined
};

// $FlowFixMe
export default connect(
  (store) => ({
    powerRating: {
      title: get(store, "capi.messages.powerRatingTitle", ""),
      image: <PowerRatingImage />,
      description: get(store, "capi.messages.powerRatingDescription", ""),
      notApplicable: get(store, "capi.messages.notApplicablePowerRating", ""),
      tip: get(store, "capi.messages.powerRatingTip", "")
    },
    highSpeed: {
      title: get(store, "capi.messages.highSpeedTitle", ""),
      image: null,
      description: get(store, "capi.messages.highSpeedDescription", ""),
      notApplicable: get(store, "capi.messages.notApplicableHighSpeed", ""),
      tip: get(store, "capi.messages.highSpeedTip", "")
    },
    winPerc: {
      title: get(store, "capi.messages.winPercTitle", ""),
      image: <CarrerFirstImage />,
      description: get(store, "capi.messages.winPercDescription", ""),
      tip: get(store, "capi.messages.winPercTip", "")
    },
    topPerc: {
      title: get(store, "capi.messages.topPercTitle", ""),
      image: <CarrerTopImage />,
      description: get(store, "capi.messages.topPercDescription", ""),
      tip: get(store, "capi.messages.topPercTip", "")
    },
    coupled: {
      title: get(store, "capi.messages.coupledTitle", ""),
      image: null,
      description: get(store, "capi.messages.coupledDescription", ""),
      tip: get(store, "capi.messages.coupledTip", "")
    },
    numberFire: {
      title: get(store, "capi.messages.numberFireTitle", ""),
      image: null,
      description: get(store, "capi.messages.numberFireDescription", ""),
      tip: get(store, "capi.messages.numberFireTip", "")
    },
    racingAndSports: {
      title: parseJSONCapiMessage(
        store,
        "capi.messages.racingAndSportsContent",
        { title: "" }
      ).title,
      image: null,
      description: parseJSONCapiMessage(
        store,
        "capi.messages.racingAndSportsContent",
        { description: "" }
      ).description,
      tip: parseJSONCapiMessage(store, "capi.messages.racingAndSportsContent", {
        tip: ""
      }).tip
    },
    betTypes: get(store, "capi.messages.betTypesTutorial", ""),
    understandingPools: get(store, "capi.messages.understandingPools", ""),
    understandingOdds: get(store, "capi.messages.understandingOdds", ""),
    winProbabilityFDR: parseJSONCapiMessage(
      store,
      "capi.messages.winProbabilityFDR",
      { title: "Win probability", description: "" }
    ),
    geolocationStatus: getGeolocationStatus(store),
    geolocationMessageShown: getGeolocationMessageShown(store),
    geoLocationToastMsg: parseJSONCapiMessage(
      store,
      "capi.messages.geoLocationToastMsg",
      {}
    ),
    currentBetType: get(store, "RaceProgram.betType"),
    storedSlugContent: get(
      store,
      "educationalHub.storedSlugsData.modals/betting"
    )
  }),
  (dispatch: Dispatch<*>) => ({ dispatch })
)(HelpModal);
